module.exports = __webpack_public_path__ + "img/pbi1.f8596f08.png";